import React from 'react';
// import { Icon, InlineIcon } from '@iconify/react';
// import codechefIcon from '@iconify-icons/simple-icons/codechef';
import styled from 'styled-components';
import Bounce from 'react-reveal/Bounce';
import HorizontalLine from './HorizontalLine';
import SectionTitle from './SectionTitle';
import CPItem from './CPItem';
// import codeforcesImg from '../assets/images/codeforces.png';
import codeforcesImg from '../assets/images/code-forces.png';
import codechefImg from '../assets/images/codechef.png';
import leetcode from '../assets/images/logoleetcode.png';

const CPItemStyles = styled.div`
  padding: 10rem 0;
  .cp__allItems {
    display: flex;
    gap: 5rem;
    justify-content: space-evenly;
    margin-top: 5rem;
  }

  @media only screen and (max-width: 768px) {
    .cp__allItems {
      flex-direction: column;
      max-width: 350px;
      margin: 0 auto;
      margin-top: 5rem;
      gap: 5rem;
    }
  }
`;

export default function CP() {
  return (
    <CPItemStyles>
      <HorizontalLine />
      <div className="container">
        <Bounce top>
          <SectionTitle
            heading="Competitive Programming"
            subheading="Problem Solving"
          />
        </Bounce>
        <div className="cp__allItems">
          <CPItem
            icon={codechefImg}
            title="CodeChef"
            link="https://www.codechef.com/users/staffan_s_s"
          />
          <CPItem
            icon={codeforcesImg}
            title="CodeForces"
            link="https://codeforces.com/profile/staffan_s_s"
          />
          <CPItem
            icon={leetcode}
            title="Leetcode"
            link="https://leetcode.com/u/staffan_s_s/"
          />
        </div>
      </div>
    </CPItemStyles>
  );
}
